import { MapProperty, MapZoomLevel } from '@/components/maps/enums';
import { DEFAULT_MAP_COORDS } from '@/components/maps/constants';

export const UNAVAILABLE_MESSAGE = 'Data Unavailable';
export const MIN_ADDRESS_LENGTH = 3;
export const DEFAULT_MAP_CONFIG = {
  [MapProperty.Center]: DEFAULT_MAP_COORDS,
  [MapProperty.Zoom]: MapZoomLevel.Medium,
  [MapProperty.Bounds]: null,
  [MapProperty.Height]: 900,
};
